// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayLayout_container__5J5mV"};